import React from 'react';
import styles from './HomepageSlide.module.scss';

const HomepageSlide = props => {
  return (
    <div
      className={styles.slide}
      style={{
        backgroundColor: props.bgColor
      }}
      onTouchStart={(e) => props.handleTouchStart(e)}
      onTouchEnd={(e) => props.handleTouchEnd(e)}
    >
      <img
        className={styles.image}
        src={props.image}
        alt={`'slider-${props.image}'`}
      />
      <div className={styles.rightContainer}>
        <div className={styles.quote}>
          {props.quote}
        </div>
      </div>
    </div>
  );
}

export default HomepageSlide;